<template>
  <div>
    <div class="wrap">
      <div class="content">
        <FullCalendar ref="fullCalendar" :options="calendarOptions">
          <template v-slot:eventContent='arg'>
            <div class="card w-100 border-left-primary" :class="arg.event.extendedProps.cellClass || 'bg-info'">
              <div class="card-body text-start p-2">
                <div class="row no-gutters">
                  <div class="col-auto">
                    <img
                      class="pt-1"
                      :src="arg.event.extendedProps.leave.image || arg.event.extendedProps.leave.icon"
                      style="height: 25px; width: 25px" />
                  </div>
                  <div class="col pl-2">
                    <b>{{ arg.event.title }}</b>
                    <br>
                    <b>{{ arg.event.extendedProps.leave.type }}</b>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </FullCalendar>
      </div>
      <!-- <div class="panel-tag mt-3 col-sm-6 col-md-6 col-lg-6 h-50" v-if=" totalEntries == 0">
        {{ $t("table.no_records") }}
      </div> -->
    </div>
  </div>
</template>
  
<script>
import moment from "moment";
import FullCalendar from "@fullcalendar/vue";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import { handleSessionExpired } from "../../../../assets/js/dashboard/dashboard";
export default {
  name: "Calendar",
  components: {
    FullCalendar,
  },
  data: function () {
    let now = moment();
    return {
      type: 'dayGridMonth',

      calendarOptions: {
        // plugins: [dayGridPlugin, interactionPlugin, resourceTimelinePlugin],
        plugins: [dayGridPlugin, interactionPlugin],
        // defaultDate: now.startOf('week'),
        initialView: "dayGridMonth",
        events: [],
        height: 'auto',
        contentHeight: 'auto',
        // height: '600px',
        // contentHeight: '600px',
        headerToolbar: {
          left: 'prev,next',
          center: 'title',
          // right: 'dayGridMonth,dayGridWeek,resourceTimeline' // user can switch between the two
          right: 'dayGridMonth,dayGridWeek,dayGridDay' // user can switch between the two
        },
        eventClick: (info) => {
          this.$emit('showModalEdit', info.event.extendedProps.leave)
        },
        dateClick: (info) => {
          this.$emit('showModalAdd', info.date)
        },
        datesSet: (info) => {
          this.type = this.$refs.fullCalendar.getApi().view.type

          this.$emit('onCalendarDateChange', info)
        },
      },
    };
  },
  methods: {
    async setData(data) {
      this.calendarOptions.events = []

      data.forEach((element) => {

        // var obj = {};
        // obj.key = "today";
        // obj.dates = element.arrivalDate;
        // obj.start = moment(element.startDate).format("hh:mm a");
        // obj.end = moment(element.arrivalDate)
        //   .add(element.duration, "m")
        //   .format("hh:mm a")
        //   .slice(0, 19);
        // // obj.backColor = "#6aa84f";
        // // obj.borderColor = "#38761d";
        // obj.highlight = {
        //   color: "red",
        //   fillMode: "solid",
        // };

        let color = 'bg-warning'
        if (element.rejectedDate) {
          color = 'bg-danger'
        } else if (element.approvedDate) {
          color = 'bg-success'
        }

        if(this.type === 'dayGridDay') {
          let start = moment.unix(element.startDate).startOf('day')
          let end = moment.unix(element.stopDate).endOf('day')
          while(start.unix() <= end.unix()) {
            this.calendarOptions.events.push({
              title: `${element.name}`,
              leave: element,
              cellClass: color,
              classNames: "calendarEvents",
              start: moment(start).format('YYYY-MM-DD'),
              end: moment(start).format('YYYY-MM-DD'),
            });

            start.add(1, 'day')
          }
        } else {
          this.calendarOptions.events.push({
            title: `${element.name}`,
            leave: element,
            cellClass: color,
            classNames: "calendarEvents",
            start: moment.unix(element.startDate).format('YYYY-MM-DD'),
            end: moment.unix(element.stopDate).add(1, 'day').startOf('day').format('YYYY-MM-DD'),
          });
        }
      });
      
      this.$refs.fullCalendar.getApi().updateSize()
    },
  },
  mounted() {
  },
};
</script>
  
<style>
.wrap {
  display: flex;
}

.left {
  margin-right: 10px;
}

.content {
  flex-grow: 1;
}

.fc-h-event {
  border: 1px solid white;
}
</style>
  